import React from "react";

import Table from "../../common/Table";
import RowPhoto from "../../common/TdImg";

import { Link } from "react-router-dom";

const PastBalanceList = ({ data, query }) => {
  const renderLink = (e) => {
    return (
      <Link to={`/mis/teachersBalances/${e.faculty_id}`}>{e.faculty}</Link>
    );
  };

  const columns = [
    { path: "id", label: "شماره" },
    { path: "faculty", label: "پوهنحی", content: (e) => renderLink(e) },
    { path: "opening_balance", label: "حساب قبلی" },

    { path: "paid", label: "پرداخت شده" },
    { path: "balance", label: "باقیمانده" },
  ];

  return <Table data={data} columns={columns} query={query} />;
};

export default PastBalanceList;
